import React, { useState, useContext } from "react";
import { X } from "lucide-react";
import Instance from "../../../Services/Instance";
import config from "../../../Services/config";
import { DataContext } from "../../../Services/DataContext";
import { toast } from "react-toastify";
import "../../../Assets/Styles/NetflixList.css"

const NewLicensePopup = ({ onClose }) => {
    const { categories, refreshData } = useContext(DataContext);

    const [formData, setFormData] = useState({
        productCategory: "Streaming Video",
        number: "1",
        productName: "",
        productType: "",
        policy: "",
        productTypeSmart: "",
        keyEmail: "",
        keyPassword: "",
        keyProfile: "",
        keyPin: "",
    });

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formattedKey = `Email : ${formData.keyEmail}\nMot de passe : ${formData.keyPassword}\nCode PIN : ${formData.keyPin}`;

        try {
            await Instance.post(`${config.api_url}/new-license`, {
                ...formData,
                key: formattedKey,
            });

            toast.success("Licence ajoutée avec succès !");
            onClose();
            refreshData();
        } catch (error) {
            console.error("Erreur lors de l'ajout :", error);
            toast.error("Erreur lors de l'ajout de la licence !");
        }
    };

    return (
        <div className="netflix-popup-overlay">
            <div className="netflix-popup-container">
                <div className="netflix-popup-close" onClick={onClose}>
                    <X className="netflix-popup-close-icon" />
                </div>
                <h2 className="netflix-popup-title">Ajouter une Nouvelle Licence</h2>
                <form onSubmit={handleSubmit} className="netflix-popup-form">

                    <div className="netflix-popup-form-item">
                        <label className="netflix-popup-label">Nom du Produit</label>
                        <select
                            className="netflix-popup-select"
                            name="productName"
                            value={formData.productName}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="">Sélectionner un produit</option>
                            {categories &&
                                categories
                                    .filter((category) => category.categoryName === "Streaming Video")
                                    .map((item, index) => (
                                        <optgroup key={index} label={item.categoryName}>
                                            {item.productsName
                                                .filter((product) => product.toLowerCase().includes("netflix"))
                                                .map((product, idx) => (
                                                    <option key={idx} value={product}>
                                                        {product}
                                                    </option>
                                                ))}
                                        </optgroup>
                                    ))}
                        </select>
                    </div>
                    <div className="netflix-popup-form-item">
                        <label className="netflix-popup-label">Type de Produit</label>
                        <input
                            className="netflix-popup-input"
                            value={formData.productType}
                            name="productType"
                            type="text"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="netflix-popup-form-item">
                        <label className="netflix-popup-label">Policy</label>
                        <input
                            className="netflix-popup-input"
                            value={formData.policy}
                            name="policy"
                            type="text"
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="netflix-popup-form-item">
                        <label className="netflix-popup-label">Type d'Abonnement Netflix</label>
                        <select
                            className="netflix-popup-select"
                            value={formData.productTypeSmart}
                            name="productTypeSmart"
                            onChange={handleInputChange}
                        >
                            <option value="">Sélectionner un type</option>
                            <option value="Smart TV">Smart TV</option>
                            <option value="Phone/Pc">Phone/Pc</option>
                        </select>
                    </div>

                    <div className="">
                        <label className="netflix-popup-label">Détails de l'Abonnement</label>
                        <div className="netflix-popup-form-item-group">
                            <input
                                className="netflix-popup-input netflix-popup-form-item"
                                placeholder="Email"
                                name="keyEmail"
                                type="text"
                                value={formData.keyEmail}
                                onChange={handleInputChange}
                                required
                            />
                            <input
                                className="netflix-popup-input netflix-popup-form-item"
                                placeholder="Mot de passe"
                                name="keyPassword"
                                type="text"
                                value={formData.keyPassword}
                                onChange={handleInputChange}
                                required
                            />
                            {/* <input
                                className="netflix-popup-input netflix-popup-form-item"
                                placeholder="Profil"
                                name="keyProfile"
                                type="text"
                                value={formData.keyProfile}
                                onChange={handleInputChange}
                            /> */}
                            <input
                                className="netflix-popup-input netflix-popup-form-item"
                                placeholder="Code PIN"
                                name="keyPin"
                                type="text"
                                value={formData.keyPin}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="netflix-popup-form-submit">
                        <button type="submit" className="netflix-popup-submit-btn">
                            Ajouter
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default NewLicensePopup;
